<template>
    <div class="container">
        <h2 class="title is-5">computedを使った計算のサンプル</h2>
        <p>算出プロパティ(computed)を使った計算のサンプルコードです</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <ComputedDataComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/5ed9f55215dbd831916713189ad04601" data-iframely-url="//cdn.iframe.ly/Vyeg4FJ"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>算出プロパティ(computed)は、テンプレート内のデータを計算したり判断したりするのに便利です。</p>
        <p>このサンプルでは、a + b の計算結果を表示します。v-modelによって数字を変更すると計算結果が変わります</p>
        <p>*JavascriptのNumber()で数字に変換してます。数字以外を入れると「NaN」が返ってくるので注意</p>
        <p></p>
    </div>
</template>

<script>
import ComputedDataComponent from  '@/components/ComputedDataComponent.vue'
export default {
    components:{
        ComputedDataComponent
    },
    mounted(){
        const title = "computedを使った計算のサンプル｜あめねこサンプルコード集"
        const description = "Vue.jsで書かれたcomputedを使った計算のサンプルコードです。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "computedを使った計算のサンプルコード" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/computed-data";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
    padding: 10px;
}

</style>